export default __webpack_public_path__ + "static/1-d37ccfd4d58158fd9e52bd874da4216a.png";